// extracted by mini-css-extract-plugin
export default {"content":"month-selector_content__U9C9S","placeHolderShimmer":"month-selector_placeHolderShimmer__H8DGr"};